export { default } from './Valors';
